import { Dropdown } from "rsuite";

import DropdownMenuDivider from "../Menus/DropdownMenuDivider";
import useCloudPermissions from "../../hooks/useCloudPermissions";
import DropdownOptionWithIcon from "../Menus/DropdownOptionWithIcon";
import { Filter } from "../../types/GlobalInterfaces";

interface Props {
  currentFilter: Filter | undefined | null;
  savedFilters: any[];
  openManage: () => void;
  updateFilters: (filter: any) => void;
}

const FiltersOptions = ({
  currentFilter,
  savedFilters = [],
  openManage,
  updateFilters,
}: Props) => {
  const { cPermissions } = useCloudPermissions();

  return (
    <>
      <Dropdown.Menu className="px-3 mb-1">
        {savedFilters?.map((f) => (
          <DropdownOptionWithIcon
            key={f.id}
            name={f.Name}
            onClick={() => updateFilters(f)}
            icon={"mdi mdi-filter"}
            active={JSON.stringify(f.Filters) === JSON.stringify(currentFilter)}
          />
        ))}
        {savedFilters?.length < 1 && (
          <div
            className="tw:py-3 tw:mb-3 tw:bg-superlight tw:px-4 tw:rounded tw:text-dark tw:font-medium tw:text-xs"
            style={{
              whiteSpace: "pre-wrap",
              color: "var(--medium)",
            }}
          >
            Add your first Filter in the settings below to get started.
          </div>
        )}
        <div className="mx--3">
          <DropdownMenuDivider />
        </div>
        <div className="mx--2">
          <DropdownOptionWithIcon
            disabled={!cPermissions.cloud_modify_page}
            icon="mdi mdi-cog"
            name="Saved Filters Settings"
            onClick={openManage}
          />
        </div>
      </Dropdown.Menu>
    </>
  );
};

export default FiltersOptions;
